module.exports = __webpack_public_path__ + "static/family3-aea64aed310f5ed360897786bbb3a9a3.png";